import Vue from "vue";
import Vuex from "vuex";
import auth from "./modules/auth";
import main from "./modules/main";
import order from "./modules/order";
import processor from "./modules/processor";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    // main app storage is not namespaced
    main,

    auth: {
      namespaced: true,
      ...auth
    },

    order: {
      namespaced: true,
      ...order
    },

    processor: {
      namespaced: true,
      ...processor
    }
  }
});
